var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketspaceastronomyspaceshipsatellite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 512 512",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "element_f7449380"
  }, "\n\t.st0{fill:#0A557F;}\n\t.st1{fill:#CFF1FF;}\n\t.st2{fill:#4CC3F2;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "element_b7496f13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -99.7449 380.7263)",
    width: 67.3,
    x: 376,
    y: 303.3,
    id: "element_010a6ead"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -139.457 364.2759)",
    width: 15,
    x: 362.5,
    y: 343,
    id: "element_05629ad4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 37.8495 191.83)",
    width: 67.3,
    x: 216.8,
    y: 42.7,
    id: "element_b05a5ddf"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1.8676 175.3689)",
    width: 15,
    x: 203.3,
    y: 82.4,
    id: "element_c3c1910c"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "57,254.4 129.1,182.2 216.6,163.1 111.3,268.4  ",
    id: "element_dbe8bfc8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "138.3,419.6 120,401.3 144.7,376.6 134.1,366 109.4,390.7 93.3,374.6 137.2,311 200,373.7  ",
    id: "element_b1322b8e"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 155.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -173.2893 227.4088)",
    width: 24.8,
    x: 175.5,
    y: 245.2,
    id: "element_d9912eed"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "328.6,381.7 256.4,453.8 242.4,399.4 347.6,294.2  ",
    id: "element_24e97f6f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M262.2,358.4L152.3,248.6L318.4,82.5l49.6,49.6l-36.1,36.1c-18.7-13.6-45-12-61.9,4.9   c-16.8,16.8-18.5,43.2-4.9,61.9l-31.3,31.3l10.6,10.6l31.3-31.3c18.7,13.6,45,11.9,61.9-4.9c16.8-16.8,18.5-43.2,4.9-61.9   l36.1-36.1l49.6,49.6L262.2,358.4z",
    id: "element_c9b8f658"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.7,181.7L329.1,72c23.9-22,49.4-33.9,73.3-40l76.3,76.3C472.6,132.3,460.8,157.8,438.7,181.7z",
    id: "element_c191dadd"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.8,13.1c-1.6-0.1-3.3-0.3-5.1-0.4c-35.6-2.9-109.6-9.1-172.6,54l-76.9,76.9l-114.6,25l-93.8,93.8   l81.9,21.2l16.7,16.7l-52.5,76.2l24.9,24.9l-14.3,14.3l10.6,10.6l14.3-14.3l27.4,27.4l73.9-54.9l16.6,16.6l21.2,81.9l93.8-93.8   l25-114.6l76.9-76.9c63-63,56.9-137,54-172.6c-0.1-1.8-0.3-3.5-0.4-5.1l-0.5-6.4L490.8,13.1z M138.3,419.6L120,401.3l24.7-24.7   L134.1,366l-24.7,24.7l-16.1-16.1l43.9-63.6l62.8,62.8L138.3,419.6z M57,254.4l72.2-72.2l87.5-19.1L111.3,268.4L57,254.4z    M251.5,369L234,386.6L124.2,276.7l17.5-17.5L251.5,369z M328.6,381.7l-72.1,72.1l-14-54.4l105.3-105.3L328.6,381.7z M262.2,358.4   L152.3,248.6L318.4,82.5l49.6,49.6l-36.1,36.1c-18.7-13.6-45-12-61.9,4.9c-16.8,16.8-18.5,43.2-4.9,61.9l-31.3,31.3l10.6,10.6   l31.3-31.3c18.7,13.6,45,11.9,61.9-4.9c16.8-16.8,18.5-43.2,4.9-61.9l36.1-36.1l49.6,49.6L262.2,358.4z M327,183.8   c12.8,12.8,12.8,33.6,0,46.4c-12.8,12.8-33.6,12.8-46.4,0c-12.8-12.8-12.8-33.6,0-46.4C293.4,171,314.2,171,327,183.8z    M478.7,108.3c-6.1,23.9-17.9,49.4-40,73.3L329.1,72c23.9-22,49.4-33.9,73.3-40L478.7,108.3z M482.3,90.7L420,28.5   c25.4-3.9,47.9-2.2,63.2-0.9C484.5,42.9,486.2,65.4,482.3,90.7z",
    id: "element_80985db8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -287.2091 180.2054)",
    width: 15,
    x: 66.4,
    y: 429.3,
    id: "element_d7b98a1f"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -293.9263 209.5747)",
    width: 42.2,
    x: 84.9,
    y: 452.1,
    id: "element_5632d2a6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 -324.727 196.7583)",
    width: 15,
    x: 67.7,
    y: 482.9,
    id: "element_e0ff288f"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -272.2441 157.2359)",
    width: 42.2,
    x: 32.6,
    y: 399.7,
    id: "element_158ffcbd"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -303.087 144.4756)",
    width: 15,
    x: 15.3,
    y: 430.6,
    id: "element_2765b6ef"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 15,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -138.0137 242.0345)",
    width: 15,
    x: 215.6,
    y: 280.1,
    id: "element_7f8ee7f5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketspaceastronomyspaceshipsatellite);
export default __webpack_public_path__ + "static/media/Rocket space astronomy spaceship satellite.d80813aa118a2e6855e36ffb93c3e243.svg";
export { ForwardRef as ReactComponent };